/* batida-konto-kalendarz.js: "Twoje daty w kalendarzu" in Moje konto (sections/batida-konto-kalendarz.liquid; 14.10, Pat).
   Under the dates card on the "Ważne daty" tab (slot "daty", assets/batida-konto.js). Shown only when Batida Connect's
   GET /apps/connect/konto says ics.enabled; everything else comes from that answer too:
     ics = {enabled, subscribe, csv, hasLink, downloadUrl, csvUrl?, url?, webcalUrl?, googleUrl?}
   - downloads: plain links to the app proxy (the signed, logged-in customer's own file), with a download name;
   - subscription (only when ics.subscribe): POST konto/ics/link | reset | off -> {ok, ics}; the block redraws from it.
   Review mode (?kontodemo=1, unpublished theme only): sample data; the link is simulated in the browser, nothing is
   saved and nothing is downloaded. Registers with the panel (window.BatidaKontoQ). */
(function () {
  'use strict';
  var el = document.querySelector('[data-v7k-feat="kalendarz"]');
  if (!el) return;
  var F; try { F = JSON.parse(el.textContent); } catch (e) { return; }
  var T = F.t || {};
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function tx(k) { return esc(T[k] || ''); }
  var CTX = null, wired = false, busy = false;
  var DEMO_ID = 'przyklad-przyklad-0001';

  function demoLink(v) {
    var url = ((window.BatidaConnect && window.BatidaConnect.api) || '/apps/connect/').replace(/connect\/$/, 'ics/') + DEMO_ID + '.ics', web = url.replace(/^https?:\/\//, 'webcal://');
    return Object.assign({}, v, { hasLink: true, url: url, webcalUrl: web, googleUrl: 'https://calendar.google.com/calendar/render?cid=' + encodeURIComponent(web) });
  }
  function demoOff(v) { var o = Object.assign({}, v, { hasLink: false }); delete o.url; delete o.webcalUrl; delete o.googleUrl; return o; }

  function paint(ctx) {
    var slot = ctx.slot('daty', 'kalendarz');
    if (!slot) return;
    var c = ctx.connect, v = c && c.ics, h = ctx.h;
    if (!(F.on || ctx.DEMO) || !v || !v.enabled) { slot.innerHTML = ''; return; }
    var dl = function (href, name, label, dark) {
      return '<a class="v7k-btn v7k-btn--sm' + (dark ? ' v7k-btn--dark' : '') + '" href="' + esc(href) + '" download="' + esc(name) + '" rel="nofollow" data-v7k-cal-dl>' + label + '</a>';
    };
    var html = '<h2 class="v7k-h2">' + tx('title') + '</h2><p class="v7k-sub">' + tx('sub') + '</p>';
    html += '<div class="v7k-cal__acts">' + dl(v.downloadUrl || '/apps/connect/konto/dates.ics', 'batida-moje-daty.ics', tx('ics'), true) +
      (v.csv && v.csvUrl ? dl(v.csvUrl, 'batida-wazne-daty.csv', tx('csv'), false) : '') + '</div>';
    if (v.subscribe) {
      html += '<div class="v7k-cal__sub">';
      if (!v.hasLink || !v.url) {
        html += '<button type="button" class="v7k-btn v7k-btn--sm" data-v7k-cal="link">' + tx('sub_btn') + '</button>' +
          '<p class="v7k-small">' + tx('sub_hint') + '</p>';
      } else {
        html += '<p class="v7k-cal__t">' + tx('sub_on') + '</p><div class="v7k-cal__acts">' +
          (v.googleUrl ? '<a class="v7k-btn v7k-btn--sm" href="' + esc(v.googleUrl) + '" target="_blank" rel="noopener nofollow" data-v7k-cal-go>' + tx('google') + '</a>' : '') +
          (v.webcalUrl ? '<a class="v7k-btn v7k-btn--sm" href="' + esc(v.webcalUrl) + '" rel="nofollow" data-v7k-cal-go>' + tx('apple') + '</a>' : '') +
          '<button type="button" class="v7k-btn v7k-btn--sm" data-v7k-cal="copy">' + tx('copy') + '</button></div>' +
          '<label class="v7k-cal__link"><span class="v7k-small">' + tx('link_label') + '</span><input type="text" readonly value="' + esc(v.url) + '" data-v7k-cal-url spellcheck="false"></label>' +
          '<p class="v7k-cal__more"><button type="button" class="v7k-linkbtn" data-v7k-cal="reset">' + tx('reset') + '</button>' +
          '<button type="button" class="v7k-linkbtn v7k-linkbtn--muted" data-v7k-cal="off">' + tx('off') + '</button></p>';
      }
      html += '<p class="v7k-small v7k-cal__priv">' + tx('privacy') + '</p></div>';
    }
    slot.innerHTML = h.box('s12 v7k-cal', html);
  }

  function copy(ctx) {
    var v = ctx.connect && ctx.connect.ics, url = v && v.url; if (!url) return;
    var done = function () { ctx.h.toast(T.copied || url); };
    var fallback = function () {
      var inp = ctx.app.querySelector('[data-v7k-cal-url]');
      try { inp.focus(); inp.select(); document.execCommand('copy'); done(); } catch (x) { ctx.h.toast(url); }
    };
    try { navigator.clipboard.writeText(url).then(done, fallback); } catch (x) { fallback(); }
  }

  function act(ctx, kind, btn) {
    if (kind === 'copy') { copy(ctx); return; }
    if (busy) return;
    if (kind === 'reset' && T.reset_confirm && !window.confirm(T.reset_confirm)) return;
    if (kind === 'off' && T.off_confirm && !window.confirm(T.off_confirm)) return;
    var c = ctx.connect, h = ctx.h;
    var after = function () {
      paint(ctx);
      if (kind === 'reset' && T.reset_done) h.toast(T.reset_done);
      if (kind === 'off' && T.off_done) h.toast(T.off_done);
      var go = ctx.app.querySelector(kind === 'off' ? '[data-v7k-cal="link"]' : '[data-v7k-cal-go]');
      if (go) go.focus();
    };
    if (ctx.DEMO) { c.ics = kind === 'off' ? demoOff(c.ics) : demoLink(c.ics); after(); return; }
    busy = true; btn.disabled = true;
    h.connectApi('POST', '/ics/' + kind, { locale: ctx.LANG }).then(function (j) {
      if (j && j.ics) c.ics = j.ics;
      busy = false; after();
    }).catch(function (err) {
      busy = false; btn.disabled = false; h.toast(h.errText(err));
    });
  }

  (window.BatidaKontoQ = window.BatidaKontoQ || []).push({ id: 'kalendarz', render: function (ctx) {
    CTX = ctx;
    paint(ctx);
    if (wired) return;
    wired = true;
    ctx.app.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null; if (!t) return;
      var b = t.closest('[data-v7k-cal]');
      if (b) { e.preventDefault(); act(CTX, b.getAttribute('data-v7k-cal'), b); return; }
      if (CTX.DEMO && t.closest('[data-v7k-cal-dl], [data-v7k-cal-go]')) { e.preventDefault(); CTX.h.blocked(); }
    });
    ctx.app.addEventListener('focusin', function (e) { if (e.target && e.target.matches && e.target.matches('[data-v7k-cal-url]')) e.target.select(); });
  } });
})();
